import { ICustomLayoutValue } from 'redesign/typings/customLayout'
import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

type TCustomLayoutData = {
    isSet?: boolean
} & ICustomLayoutValue

interface ICustomLayout extends TCustomLayoutData {
    updateCustomLayout: (value: TCustomLayoutData) => void
    updateIsSet: (value: boolean) => void
}

export const useCustomLayoutStore = create(
    persist<ICustomLayout>(
        set => ({
            layoutConfig: undefined,
            activeLayout: undefined,
            activeLoginPage: undefined,
            isSet: false,
            updateCustomLayout: ({ layoutConfig, activeLayout, activeLoginPage }) =>
                set({ layoutConfig, activeLayout, activeLoginPage, isSet: true }),
            updateIsSet: isSet => set({ isSet }),
        }),
        {
            name: '@nav:customlayout',
            storage: createJSONStorage(() => sessionStorage),
        },
    ),
)
